import { CourseDetail, Lang } from 'types';
import { CourseTemplate } from 'types/enums';

export const courseRedirectResolver = (
    course: CourseDetail,
    langDomain: Lang,
    action: () => void
) => {
    if (course?.template === CourseTemplate.Awareness) {
        return window.open(course?.demoLink, '_blank', 'noopener,noreferrer');
    } else if (course?.template === CourseTemplate.Product) {
        return window.open(course?.buyLink, '_blank', 'noopener,noreferrer');
    }

    return action();
};
